(function () {
    'use strict';
    angular.module('app').controller('TransitWarrantyProvidersController', TransitWarrantyProvidersController);
    TransitWarrantyProvidersController.$inject = [
        'TransitWarrantyProvidersTableService'
    ];

    function TransitWarrantyProvidersController(
        TransitWarrantyProvidersTableService
    ) {
        
        const vm = this;

        init();
        function init(){
            vm.transitWarrantyProvidersTableService = new TransitWarrantyProvidersTableService().tableData;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/transit-warranty/TransitWarrantyProvidersController.js